import { Component, OnInit } from '@angular/core';
import { Localiser } from '../../services/localiser';
import { Navigation } from '../../services/navigation.service';
import {UserService} from '../../services/user.service';
import {ProyectoService} from "../../services/proyecto.service";
import {proyecto} from "../../models/proyecto";
import {DeviceService} from "../../services/device.service";

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {

  info = undefined;

  constructor(public localiser: Localiser, public user: UserService, private navigation: Navigation,
              public proyectoService: ProyectoService, private deviceService: DeviceService) { }

  ngOnInit(): void {
    this.user.rechargeUser();
    this.getSimpleInfo();
  }

  toIndicators(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.navigation.toIndicators()
  }

  toAlerts(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.navigation.toAlerts();
  }

  toAteneoZones(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.navigation.toAteneoZones();
  }

  toFloorplans(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.navigation.toSelectFloorplan();
  }

  toDevices(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.deviceService.setSelectedProyecto(proyecto);
    this.navigation.toDevices();
  }

  toLastPage(proyecto: proyecto) {
    this.proyectoService.setProyectoActual(proyecto);
    this.proyectoService.toLastPage();
  }

  getSimpleInfo() {
    const proyectos = this.user.getProyectos();

    if (!proyectos || proyectos.length === 0) {
      this.info = [];
      return;
    }

    const projectIds = proyectos.map(proyecto => proyecto.idProyecto);

    this.proyectoService.getSimpleInfoList(projectIds).subscribe(
      (response: any) => {
        // Handle different response formats
        let responseArray: any[] = [];

        if (Array.isArray(response)) {
          responseArray = response;
        } else if (response && typeof response === 'object') {
          // Check if it's an object with numeric keys (like a serialized array)
          const keys = Object.keys(response).filter(k => !isNaN(Number(k)));
          if (keys.length > 0) {
            responseArray = keys.map(k => response[k]);
          } else {
            // Single object response
            responseArray = [response];
          }
        }
        this.info = responseArray.map((projectInfo, index) => {
          return this.shuffle(projectInfo, projectInfo.idProject);
        });
      },
      (error) => {
        console.error('Error loading simple info:', error);
      }
    );
  }

  shuffle(json, idProject) {    
    const indexes = [];
    const keys = Object.keys(json).filter(key => key !== 'idProject');

    for (let i = 0; i < 2 && keys.length > 0; i++) {
      const index = Math.floor(Math.random() * keys.length);
      const selectedKey = keys.splice(index, 1)[0];
      indexes.push({
        [selectedKey]: json[selectedKey]
      });
    }

    let shuffleJSON = {
      idProject: idProject,
      values: indexes
    }

    return shuffleJSON;
  }

  simpleInfoIsReady(idProject) {
    if (this.info != undefined) {
      const found = this.info.find(index => index.idProject == idProject);
      const isReady = found != undefined;
      return isReady;
    } else {
      return false;
    }
  }

  hasProjectData(idProject) {
    if (this.info != undefined) {
      const simpInfo = this.info.find(index => index.idProject == idProject);
      if (simpInfo && simpInfo.values && simpInfo.values.length > 0) {
        return true;
      }
    }
    return false;
  }

  showSimpleInfo(idProject, infoIndex, key) {
    let simpInfo = this.info.find(index => index.idProject == idProject);
    if (simpInfo != undefined && simpInfo.values && simpInfo.values.length > infoIndex) {
      let json = simpInfo.values[infoIndex];
      if (json && Object.keys(json).length > 0) {
        if (key) {
          return Object.keys(json)[0];
        } else {
          return json[Object.keys(json)[0]];
        }
      }
    }
    return undefined;
  }

}
